import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';

import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';
import {
  origemLancamentoCadastroDesconhecida,
  origemLancamentoCadastroEcommerce,
  origemLancamentoCadastroErp,
  origemLancamentoCadastroSogivendas
} from '../../../../models/origem-lancamento-cadastro';

@Component({
  selector: 'sgt-novo-origem-lancamento-cadastro-multiselect',
  templateUrl: './novo-origem-lancamento-cadastro-multiselect.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoOrigemLancamentoCadastroMultiselectComponent),
      multi: true
    }
  ]
})
export class NovoOrigemLancamentoCadastroMultiselectComponent
  extends CustomControlValueAccessor<number[]>
  implements OnInit {
  @Input() origens: number[];

  settings: IMultiSelectSettings = {
    placeholder: 'Selecione as origens',
    plural: 'Origens',
    singular: 'Origem',
    searchEmptyResultMessage: 'Nenhuma origem encontrada',
    showFooter: false
  };

  @Input() isShowDesconhecida = false;
  @Input() isShowSogivendas = true;
  @Input() isShowErp = true;
  @Input() isShowEcommerce = true;

  @Output() idsOrigensChange = new EventEmitter<number[]>();

  constructor() {
    super();
  }

  options: IOption[];

  ngOnInit() {
    this.create();
  }

  private create() {
    this.options = [];
    const selects: IOption[] = [];

    if (this.isShowDesconhecida) {
      selects.push({ id: origemLancamentoCadastroDesconhecida.id, label: origemLancamentoCadastroDesconhecida.nome });
    }
    if (this.isShowSogivendas) {
      selects.push({ id: origemLancamentoCadastroSogivendas.id, label: origemLancamentoCadastroSogivendas.nome });
    }
    if (this.isShowErp) {
      selects.push({ id: origemLancamentoCadastroErp.id, label: origemLancamentoCadastroErp.nome });
    }
    if (this.isShowEcommerce) {
      selects.push({ id: origemLancamentoCadastroEcommerce.id, label: origemLancamentoCadastroEcommerce.nome });
    }

    this.options = selects;
  }

  onSearch() {
    this.idsOrigensChange.emit(this.origens);
  }

  onChangeOrigensLancamentos() {
    this.emitChange(this.origens);
  }

  protected updateValue(newValue: number[] | null): void {
    this.origens = newValue || [];
  }
}
